// 再加工state (主要用于对数组、对象、变量的再加工)
import store from '../store'
import { getUserInfo } from '../utils/api'

export const userInfo = state => {
    let userInfo = state.userInfo;
    if (!userInfo) {
        userInfo = getUserInfo();
        userInfo && store.commit('updateUserInfo', userInfo)
    }
    return userInfo;
}